import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { IGetParams, IListResponse } from '@/api/types';
import { ApiVersion } from '@/config';
import { IMarkerType } from '@/models';

export const MarkerTypeApi = {
  getMarkerTypes: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IMarkerType>>> => {
    return http.get(`api/${ApiVersion.V2}/marker-types`, { params });
  },

  getMarkerType: (id: string): Promise<AxiosResponse<IMarkerType>> => {
    return http.get(`api/${ApiVersion.V2}/marker-types/${id}`);
  },

  createMarkerType: (
    data: Partial<IMarkerType>,
  ): Promise<AxiosResponse<{ message: string; data: IMarkerType }>> => {
    return http.post(`api/${ApiVersion.V2}/marker-types`, data);
  },

  updateMarkerType: (
    id: string,
    data: Partial<IMarkerType>,
  ): Promise<AxiosResponse<{ message: string; data: IMarkerType }>> => {
    return http.put(`api/${ApiVersion.V2}/marker-types/${id}`, data);
  },

  deleteMarkerType: (id: string): Promise<AxiosResponse<void>> => {
    return http.delete(`api/${ApiVersion.V2}/marker-types/${id}`);
  },
};
